import { register } from 'tmr/tmr/ngModuleRegistry'

import * as matchValue from './matchValue/matchValue'
import * as requiredCheckboxes from './requiredCheckboxes/requiredCheckboxes'
import * as requiredChips from './requiredChips/requiredChips'
import * as uniqueKey from './uniqueKey/uniqueKey'
import * as uniqueResourceValue from './uniqueResourceValue/uniqueResourceValue'
import * as validatePassword from './validatePassword/validatePassword'

export default register(
  'tmr.core.directives.validators',
  matchValue,
  requiredCheckboxes,
  requiredChips,
  uniqueKey,
  uniqueResourceValue,
  validatePassword
)
